__turbopack_context__.v({
  "menu": "DropdownMenuV2-module__zQtVDW__menu",
});
